<template>
  <div class="position-relative">
    <div :id="fn_isNull(id)? id :'map'" class="w-100">
      <div class="marker-custom">
      </div>
      <!--      <div class="input-group mb-3 input-search" >-->
      <!--      <input type="text" class="form-control" aria-label="Text input with checkbox">-->
      <!--      </div>-->
    </div>
  </div>
</template>
<style scoped>
  #map {
    position: relative;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 250px;
  }

  .marker-custom {
    top: 31%;
    left: 45%;
    position: absolute;
    background-image: url('../../public/img/marker.png');
    background-size: cover;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    cursor: pointer;
    z-index: 1;
  }

  /*.input-search {*/
  /*top: 5px;*/
  /*right: 5px;*/
  /*position: absolute;*/
  /*background-size: cover;*/
  /*width: auto;*/
  /*height: 50px;*/
  /*border-radius: 50%;*/
  /*cursor: pointer;*/
  /*z-index: 1;*/
  /*opacity: 95%;*/
  /*}*/


</style>
<script>
  import mapboxgl from 'mapbox-gl'
  import MapApi from '../moduleApi/MapApi'
  import MethodService from "../service/MethodService";

  export default {
    props: {
      value: Object,
      cordinatesValue: Array,
      id: String,
      disabled: Boolean
    },
    data() {
      return {
        mData: {
          dataDefault: {
            token: 'pk.eyJ1IjoibXJoYTE0MDc5OSIsImEiOiJjazd5Z2V3cHAwNnY2M2VwMXYxZzB6dW5sIn0.D1U9nZ4xJSL_gLb9FoNcGA',
            style:'mapbox://styles/mapbox/streets-v11',
            mapDataObject: {
              value: [],
              geoJsonData: {
                type: '',
                geometry: {},
              }
            },
            cordinatesValueProps: [],
          },
        },
      }
    },

    methods: {
      async fn_initMap(map) {
        var _this = this;
        mapboxgl.accessToken = this.mData.dataDefault.token;
        if (MethodService.isUndefined(map)) {
          map = new mapboxgl.Map({
            container: _this.fn_isNull(_this.id)?_this.id : 'map', // container id
            style: _this.mData.dataDefault.style, // stylesheet location
            center: MethodService.isUndefined(_this.cordinatesValue) ? [105.75, 21] : _this.cordinatesValue, // starting position [lng, lat]
            zoom: 15, // starting zoom
            interactive: !_this.disabled
          });
        }
        let geocoder = new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          marker: null,
          mapboxgl: mapboxgl
        });

        if (!_this.disabled) {
          map.addControl(geocoder);
        }
        map.addControl(new mapboxgl.NavigationControl());

        _this.mData.dataDefault.mapDataObject = await _this.fn_getGeoJsonData(map);
        _this.$emit('update', _this.mData.dataDefault.mapDataObject);
        map.on('mouseup', async function (e) {
          _this.mData.dataDefault.mapDataObject = await _this.fn_getGeoJsonData(map);
          _this.$emit('update', _this.mData.dataDefault.mapDataObject);
        });
        map.on('wheel', async function (e) {
          _this.mData.dataDefault.mapDataObject = await _this.fn_getGeoJsonData(map);
          _this.$emit('update', _this.mData.dataDefault.mapDataObject);
        });
        map.on('load', function () {
          // Listen for the `result` event from the Geocoder
          // `result` event is triggered when a user makes a selection
          //  Add a marker at the result's coordinates
          geocoder.on('result', async function (e) {
            let res = await MapApi.searchByLngLat({
              long: e.result.center[0],
              lat: e.result.center[1]
            }, mapboxgl.accessToken);
            let featureLast = res.features.pop();
            let result = {
              value: [e.result.center[0], e.result.center[1]],
              geoJson: {
                type: featureLast.geometry.type,
                coordinates: res.query
              }
            };
            _this.mData.dataDefault.mapDataObject = result;
            _this.$emit('update', _this.mData.dataDefault.mapDataObject);
          });
        });
        _this.mData.mapBox = map;
      },
      fn_isNull(value) {
        return MethodService.isNull(value);
      },

      async fn_getGeoJsonData(map) {
        let result = await MapApi.searchByLngLat({
          long: map.getCenter().lng,
          lat: map.getCenter().lat
        }, mapboxgl.accessToken);
        let featureLast = result.features.pop();
        return {
          value: [map.getCenter().lng, map.getCenter().lat],
          geoJson: {
            type: featureLast.geometry.type,
            coordinates: result.query
          }
        };
      }
    },
    created() {
    },
    mounted: async function () {
      await this.fn_initMap();
    },

  };


</script>


